"use client";

import { useState } from "react";

import { TrackedCTALink } from "@/components/analytics/tracked-cta";
import { GuestBundleCheckoutDialog } from "@/components/offer/guest-bundle-checkout-dialog";
import { BUNDLE_PRICE } from "./content";

const idr = new Intl.NumberFormat("id-ID");
const rp = (n: number) => `Rp${idr.format(n)}`;

/**
 * Client wrapper for the Career Booster bundle CTAs. Opens a guest checkout
 * dialog (QRIS → Google OAuth → claim) instead of routing to sign-up first.
 */
export function CareerBoosterCta({
  locale,
  variant,
  children,
}: {
  locale: string;
  variant: "primary" | "outline";
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TrackedCTALink
        href="#"
        context="career-booster-pricing"
        locale={locale}
        event="offer_bundle_cta"
        eventParams={{ source: "career_booster_lp" }}
        onClick={(e: React.MouseEvent) => {
          e.preventDefault();
          setOpen(true);
        }}
        className={
          variant === "primary"
            ? "mt-5 inline-flex min-h-12 w-full items-center justify-center rounded-lg bg-primary px-6 text-sm font-semibold text-primary-foreground transition-all hover:bg-primary/90 active:translate-y-px sm:w-auto sm:px-10"
            : "inline-flex min-h-12 items-center justify-center rounded-lg border px-7 text-sm font-semibold transition-colors hover:bg-muted"
        }
      >
        {children}
      </TrackedCTALink>
      <GuestBundleCheckoutDialog
        open={open}
        onOpenChange={setOpen}
        amount={BUNDLE_PRICE}
      />
    </>
  );
}
